/**
 * Shopify product status for the frontend (2026-10-30). Mirror of
 * backend/utils/shopifyProductStatus.js (CRA cannot import backend code).
 *
 * UNLISTED sells like ACTIVE (bought by direct link) but is hidden from
 * storefront search, collections and recommendations.
 *   - isSellableStatus: ACTIVE or UNLISTED.
 *   - isListedStatus: ACTIVE only (shows in storefront search/collections).
 * Case-insensitive; a missing status is neither.
 */

export function normalizeProductStatus(status) {
  return String(status == null ? '' : status).trim().toUpperCase();
}

export function isSellableStatus(status) {
  const s = normalizeProductStatus(status);
  return s === 'ACTIVE' || s === 'UNLISTED';
}

export function isListedStatus(status) {
  return normalizeProductStatus(status) === 'ACTIVE';
}

const STATUS_CHIPS = {
  UNLISTED: {
    label: 'Unlisted',
    tone: 'info',
    title: 'Unlisted on Shopify: customers can buy it with a direct link, but it is hidden from store search and collections.'
  },
  DRAFT: {
    label: 'Draft',
    tone: 'warning',
    title: 'Draft on Shopify: not for sale yet, customers cannot see or buy it.'
  },
  ARCHIVED: {
    label: 'Archived',
    tone: 'critical',
    title: 'Archived on Shopify: no longer for sale, customers cannot see or buy it.'
  }
};

/**
 * Chip for the Products card, or null. ACTIVE (and a missing or unknown
 * status) shows nothing, so normal live products stay uncluttered.
 */
export function productStatusChip(status) {
  return STATUS_CHIPS[normalizeProductStatus(status)] || null;
}
